export default __webpack_public_path__ + "static/media/AdrianTroncoso.12a83e62.png";